const img = require('./Status.png'); export default img;